import { computed } from 'mobx';
import RhApiModel   from '../abstracts/RhApiModel';

export default class TokenRefreshModel extends RhApiModel {
	static get path(): string {
		return '/token/refresh';
	}

	@computed
	public get token(): string {
		return this.get('token', '');
	}

	@computed
	public get refreshToken(): string {
		return this.get('refresh_token', '');
	}

	@computed
	public get refresh_token() {
		return this.refreshToken;
	}
}
